<template>
  <div class="h5legalService" :style="{
    minHeight: `calc(100vh - ${topHeight || 0}px )`,
  }">
    <banner :themeColor="'#fff'"></banner>
    <div ref="notaryServicesref" class="legalService_content">
      <!-- 专业法律服务资源 -->
      <div class="legalService_content_title">专业法律服务资源</div>
      <div ref="tabsContainer" class="legalService_tabs">
        <div class="legalService_tabs_item" v-for="(item, index) in tabsItem" :key="index"
          @click="tabsClick(item._id, item.sort, index)">
          <div>{{ item.flmc }}</div>
          <div class="" :class="item._id == tabsIndex ? 'tabs_item_line' : 'tabs_item_line1'"></div>
        </div>
      </div>
      <el-carousel height="11.4rem" indicator-position="outside"
        :arrow="lsgListData.length > carouselItemCount ? 'hover' : 'never'" class="legalService_content_carousel">
        <el-carousel-item v-for="item in swiperNumber" :key="item">
          <div class="carousel_item_body">
            <div class="carousel_item_box" ref="carouselItemBox"
              v-for="(items, indexs) in lsgListData.slice((item - 1) * carouselItemCount, item * carouselItemCount)"
              :key="items">
              <div class="carousel_item_titleImg">
                <div class="carousel_item_img">
                  <img v-if="items.lstp" :src="commenUrl + items.lstp" alt="">
                  <img v-else src="@/assets/images/notaryServicers/mrLs.png" alt="">
                </div>
                <div class="carousel_item_img1" v-if="items.lslogo">
                  <!-- <img :src="commenUrl+items.lslogo"  alt=""> -->
                  <el-image style="width: 100%; height: 100%" :src="commenUrl + items.lslogo" fit="contain" />
                </div>
              </div>
              <div class="carousel_item_title">
                <div class="carousel_item_title_text">{{ items.lsmc }}</div>
                <div class="carousel_item_title_text1">
                  <div v-html="items.lsjs"></div>
                </div>
              </div>
              <el-carousel height="150px" indicator-position="none" :arrow="items.lawyers.length > 1 ? 'hover' : 'never'"
                :autoplay="false">
                <el-carousel-item v-for="item1 in Math.ceil(items.lawyers.length / 2)" :key="item1">
                  <div class="carousel_item_lawyer">
                    <div class="carousel_item_lawyer_body" v-for="lawyers in items.lawyers.slice((item1 - 1) * 4, item1 * 4)"
                      :key="lawyers">
                      <div class="carousel_item_lawyer_box">
                        <div class="carousel_item_lawyer_img">
                          <img v-if="lawyers.zp" :src="commenUrl + lawyers.zp" alt="">
                          <img v-else src="@/assets/images/notaryServicers/mrAvatar.png" alt="">
                        </div>
                        <div class="carousel_item_lawyer_text">{{ lawyers.lsxm }}</div>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>

            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <!-- 定制化公证咨询服务 -->
      <customization :tabsItem="tabsItem" :themeColor="themeColor"></customization>
      <!-- <div id="allMap" ></div> -->
    </div>
  </div>
</template>

<script>
// Removed duplicate export default
import { getCurrentInstance, ref, watch, computed, nextTick, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import customization from "./components/customization.vue";
import banner from '@/components/bannerMobile.vue'
import MapObject from "@/components/map/js/map";
import mapTdt from "@/components/map/dialogMap.vue"
export default {
  name: "legalService",
  props: {
    themeColor: {
      type: String,
      default: 'blue'
    },
    topHeight: {
      type: Number,
      default: 0
    }
  },
  components: {
    customization, banner
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    let articleData = ref({});

    const carouselItemBox = ref(null)
    const tabsIndex = ref(0);
    const tabsItem = ref([])
    const tabsContainer = ref(null);
    const tabsClick = (id, sort, index) => {
      tabsIndex.value = id
      console.log(sort, 'sort')
      getlsglList(id, sort)

      // 添加滚动逻辑
      if (tabsContainer.value) {
        const tabs = tabsContainer.value.querySelectorAll('.legalService_tabs_item');
        if (tabs[index]) {
          const containerWidth = tabsContainer.value.offsetWidth;
          const tabLeft = tabs[index].offsetLeft;
          const tabWidth = tabs[index].offsetWidth;

          // 计算滚动位置，使当前标签居中
          const scrollPosition = tabLeft - (containerWidth / 2) + (tabWidth / 2);

          // 执行滚动
          tabsContainer.value.scrollTo({
            left: scrollPosition,
            behavior: 'smooth' // 平滑滚动效果
          });
        }
      }
    }


    const getTyleList = () => {   //法律类型接口
      proxy.$request({
        url: "TYPE_LIST",
        method: "post",
        data: {}
      }).then((res) => {
        if (res.data.code == "000") {
          res.data.result.forEach((item, index) => {
            if (index <= 3) {
              tabsItem.value.push({
                sort: index + 1,
                ...item
              })
            } else {
              if (index == 4) {
                tabsItem.value.push({
                  sort: 1,
                  ...item
                })
              } else if (index == 5) {
                tabsItem.value.push({
                  sort: 2,
                  ...item
                })
              } else if (index == 6) {
                tabsItem.value.push({
                  sort: 3,
                  ...item
                })
              } else if (index == 7) {
                tabsItem.value.push({
                  sort: 4,
                  ...item
                })
              }
            }
          });
          tabsIndex.value = res.data.result[0]._id
          getlsglList(res.data.result[0]._id, 0)
        }
      }).catch((err) => {
        console.log(err);
      });
    }
    // getTyleList()
    // LSGL_LIST
    const lsgListData = ref([])
    const getlsglList = (id, sort) => {  //律所列表
      proxy.$request({
        url: "LSGL_LIST",
        method: "post",
        data: {
          fwflId: id,
          sort: sort
        }
      }).then((res) => {
        if (res.data.code == "000") {
          lsgListData.value = res.data.result;
          swiperNum()
        }
      }).catch((err) => {
        console.log(err);
      });
    }
    const swiperNumber = ref(0)  //轮播图一页显示几个个数量
    const swiperNum = () => {

      swiperNumber.value = Math.ceil(lsgListData.value.length / carouselItemCount.value);
    }
    const notaryServicesref = ref(null);

    const footerHeight = ref(0);
    const carouselItemCount = ref(1)
    onMounted(async () => {
      await nextTick();
      //  initMap()
      if (notaryServicesref.value) {
        carouselItemCount.value = 1
        footerHeight.value = notaryServicesref.value.offsetHeight
        getTyleList()
      }

      const debounce = (fn, delay) => {
        let timer = null;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(() => {
            fn.apply(this, arguments);
          }, delay);
        };
      };

      const debounceSwipNum = debounce(() => {
        if (notaryServicesref.value) {
          carouselItemCount.value = notaryServicesref.value.offsetWidth == 1600 ? 4 : 3
          footerHeight.value = notaryServicesref.value.offsetHeight
          swiperNum()
        }
      }, 200);

      window.addEventListener('resize', debounceSwipNum);
    });

    return {
      articleData,
      notaryServicesref,
      tabsClick,
      tabsIndex,
      tabsItem,
      carouselItemBox,
      carouselItemCount,
      lsgListData,
      swiperNumber,
      tabsContainer
    };
  },
};
</script>


<style lang="less" scoped>
.h5legalService {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  box-sizing: border-box;
  padding-bottom: 50px;

  .legalService_content {
    // padding: 0 150px;
    width: 7.5rem;
    margin: 0 auto;
    box-sizing: border-box;

    .legalService_content_title {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: .4rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: .36rem;
      color: #313A4B;
      line-height: .56rem;
    }

    /* 同时确保 .legalService_tabs 的滚动条样式正确 */
    .legalService_tabs {
      /* 其他样式保持不变 */
      overflow-x: auto;
      /* 使用auto而不是scroll，只有在需要时才显示滚动条 */
      scrollbar-width: none;
      /* 对于Firefox浏览器 */
      -ms-overflow-style: none;
      /* 对于IE浏览器 */
    }

    /* 对于Chrome、Safari和Opera浏览器，隐藏滚动条但保留滚动功能 */
    .legalService_tabs::-webkit-scrollbar {
      display: none;
    }

    .legalService_tabs {
      padding: 0 .28rem;
      cursor: pointer;
      margin: 0 auto;
      // width: 1000px;
      height: 40px;
      /* 设置固定高度，适合水平排列 */
      overflow-x: scroll;
      /* 仅水平滚动 */
      overflow-y: hidden;
      /* 隐藏垂直滚动 */
      display: flex;
      flex-direction: row;
      /* 水平排列 */
      justify-content: flex-start;
      /* 左侧对齐 */
      align-items: center;
      /* 垂直居中 */
      margin-top: .24rem;
      // padding-bottom: 10px;
      white-space: nowrap;

      /* 防止子元素换行 */
      .legalService_tabs_item {
        font-weight: 600;
        font-size: .28rem;
        padding: 0 .6rem .12rem 0;
        /* 添加左右间距 */
        margin-right: 10px;
        /* 添加右侧间距 */
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .tabs_item_line {
          width: .48rem;
          height: .05rem;
          background: #191919;
          margin-top: .12rem;
        }
      }

      .tabs_item_line1 {
        width: .48rem;
        height: .05rem;
        // background: #191919;
        margin-top: .12rem;
      }

      .tabs_item_active {
        font-weight: 500;
        font-size: 14px;
        color: #313A4B;
        // border-bottom: 2px solid #313A4B;
      }
    }
  }

  .legalService_banner {
    box-sizing: border-box;
    width: 100%;
    height: 400px;
    background: url('@/assets/images/notaryServicers/flfwbanner.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .banner_title {
      font-size: 46px;
      font-weight: bold;
      color: #FFFFFF;
    }

    .banner_text {
      margin-top: 20px;
      font-size: 24px;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
}

.legalService_content_carousel {
  margin-top: .4rem;
  padding: 0 .28rem;
}

.carousel_item_body {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  /* 3列，每列等宽 */
  gap: 20px;
  /* 设置间隔 */
  //  border-bottom: 1px solid #000; /* 添加下边框 */
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  /* 确保边框包含在高度内 */
  // margin: 30px 0;
  .carousel_item_box {
    box-sizing: border-box;
    width: 100%;
    margin-right: 20px;
    // width: 32%;
    height: 97%;
    border: 1px solid #D5DCEB;
    border-radius: 20px;

    // background: red;
    .carousel_item_titleImg {
      box-sizing: border-box;
      width: 100%;
      // height: 100%;
      position: relative;

      .carousel_item_img {
        width: 100%;
        height: 4.34rem;

        img {
          width: 100%;
          height: 100%;
          border-top-right-radius: 20px;
          border-top-left-radius: 20px;
        }
      }

      .carousel_item_img1 {
        width: 93px;
        height: 86px;
        position: absolute;
        bottom: -31px;
        right: 17px;
        background: #FFFFFF;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .carousel_item_title {
      box-sizing: border-box;
      padding: 0 20px;

      .carousel_item_title_text {
        font-weight: 600;
        font-size: 20px;
        color: #313A4B;
        margin-top: .78rem;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        /* 显示的行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .carousel_item_title_text1 {
        width: 100%;
        margin-top: .22rem;
        font-weight: 400;
        font-size: .26rem;
        color: #57647C;
        line-height: .48rem;
        height: 2.4rem;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        /* 显示的行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;

        div p img {
          width: 100%;
          display: none !important;
          visibility: hidden !important;
          visibility: hidden !important;
        }

        // img{

        // }

        //  white-space: nowrap;
      }
    }

    .carousel_item_lawyer {
      width: 100%;
      margin-top: 20px;
      padding: 0 20px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      /* 4列，每列等宽 */
      gap: 10px;
      /* 设置间隔 */
      width: 100%;
      height: 100%;
      justify-content: space-between;

      .carousel_item_lawyer_body {

        // display: flex;
        .carousel_item_lawyer_box {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .carousel_item_lawyer_img {
            width: 66px;
            height: 66px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }

          .carousel_item_lawyer_text {
            font-weight: 400;
            font-size: 14px;
            color: #313A4B;
            margin-top: 12px;
          }
        }
      }
    }

  }
}



// @media (min-width: 1680px) {

// .h5legalService{
//     .legalService_content {
//         width: 7.5rem;
//          margin: 0 auto;
//          .legalService_content_carousel {
//             .carousel_item_body {
//                 display: grid;
//                 grid-template-columns: repeat(1, 1fr); /* 4列，每列等宽 */
//                 gap: 10px; /* 设置间隔 */
//                 width: 100%;
//                 height: 100%;
//                  .carousel_item_box {
//                   width: 97%;
//                     // width: 24%;
//           }
//             }
//          }

//     }

// }
// }
:deep(.carousel__indicators) {
  margin-top: 30px;
}

:deep(.el-carousel__button) {
  // .el-carousel__button {
  background-color: #000000 !important;
  border-radius: .04rem !important;
  background: #000000 !important;
  width: .38rem !important;
  height: .08rem !important;
  // }

}

:deep(img, video, audio) {
  width: 100%;
}

#allMap {
  height: 400px;
}
</style>